import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import { toast, Toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'assets/css/common.css';
import { CircularProgress } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';

function RegisterConfirmation() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const baseUrl = configurations.baseUrl;
    const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
    const [isLoading, setIsLoading] = useState(false);

    const { register, setValue, handleSubmit, formState: { errors } } = useForm();

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const paramsObj = Object.fromEntries(urlSearchParams.entries());
        if (paramsObj.email) {
            setValue('email', paramsObj.email);
        }
        if (paramsObj.token) {
            setValue('token', paramsObj.token);
        }
    }, []);

    const onSubmit = async (data) => {
        setIsLoading(true)
        await axios.post(baseUrl + '/vendor/registerConfirmation', data,
            {
                function: azureFunctionVendorFrontendKey
            }).then((response) => {
                setIsLoading(false);
                if (response.status == 200) {
                    const message = response.data.message;
                    if (response.data.status == 1) {
                        toast.success(t(message));
                        navigate('/vendor/login');
                    }
                    else {
                        if (message != '')
                            toast.error(t(message));
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                }
            }).catch(error => {
                setIsLoading(false);
                toast.error(error);
            });
    };

    return (
        <BasicLayout image={bgImage}>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
            <Card>
                <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center">
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>{t('welcomeNote')}</MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                        <MDBox mb={2}>
                            <MDTypography variant="body1" className="labelStyle">{t('confirmText')}</MDTypography>
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton type="submit" variant="gradient" color="info" disableRipple fullWidth>{t('clickHere')}</MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

export default RegisterConfirmation;
